import { render, staticRenderFns } from "./delPdaModal.vue?vue&type=template&id=39bac3b5&scoped=true"
import script from "./delPdaModal.vue?vue&type=script&lang=js"
export * from "./delPdaModal.vue?vue&type=script&lang=js"
import style0 from "./delPdaModal.vue?vue&type=style&index=0&id=39bac3b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bac3b5",
  null
  
)

export default component.exports